/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
import axios from 'axios';

async function logout() {

    localStorage.setItem("token", '');
    window.location.href = '/cms/admin/login';

}
export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  return (
    <>
      <nav className=" bg-white md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl flex flex-wrap items-center justify-between relative md:w-64 md:z-10">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between">
          <div></div>
          {/* Toggler */}
          <button
            className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-white m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>
          {/* Brand */}
          <Link
            className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0 ml-6"
            to="/"
          >
            <img className="max-w-full object-cover h-24 w-48" src={require("../../../assets/img/fookchoong_logo1.jpg")} alt="image description"></img>
          </Link>
          {/* User */}
          <hr></hr>
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">

            </li>
            <li className="inline-block relative">

            </li>
          </ul>
          {/* Collapse */}
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            {/* Collapse header */}
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex justify-end flex-wrap">
                <div className="justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>


            {/* Navigation */}

            <ul className="md:flex-col md:min-w-full flex flex-col list-none ml-6">
              {/*
              <li className="items-center">
              <a href="/cms/admin/dashboard"
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/cms/admin/dashboard") !== -1
                      ? "text-indigo-700 hover:text-indigo-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm " +
                      (window.location.href.indexOf("/cms/admin/dashboard") !== -1
                        ? "opacity-75"
                        : "text-blueGray-500")
                    }
                  ></i>{" "}
                  主頁
                </a>
               
              </li>
             
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/cms/admin/slider") !== -1
                    ? "text-indigo-700 hover:text-indigo-500"
                    : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/cms/admin/slider"
                >
                  <i
                    className={
                      "fa fa-sliders mr-2 text-sm " +
                      (window.location.href.indexOf("/cms/admin/slider") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Slider
                </Link>
              </li>
              */}
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/cms/admin/project") !== -1
                      ? "text-indigo-700 hover:text-indigo-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/cms/admin/project"
                >
                  <i
                    className={
                      "fas fa-table mr-2 text-sm " +
                      (window.location.href.indexOf("/cms/admin/project") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  項目管理
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/cms/admin/slider") !== -1
                      ? "text-indigo-700 hover:text-indigo-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/cms/admin/slider"
                >
                  <i
                    className={
                      "fa fa-sliders mr-2 text-sm " +
                      (window.location.href.indexOf("/cms/admin/slider") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  輪播版位
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/cms/admin/comment") !== -1
                      ? "text-indigo-700 hover:text-indigo-500"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/cms/admin/comment"
                >

                  <i
                    className={
                      "fa-regular fa-comment mr-2 text-sm " +
                      (window.location.href.indexOf("/cms/admin/comment") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  留言管理
                </Link>
              </li>
            </ul>

            {/* Divider */}
            <hr className="my-4 md:min-w-full" />

            <ul className="md:flex-col md:min-w-full flex flex-col list-none md:mb-4 ml-6">

              <li className="items-center">
                <Link
                  className="text-blueGray-700 hover:text-blueGray-500 text-xs uppercase py-3 font-bold block"


                  onClick={() =>
                    logout()
                  }

                >
                  <i className="fas fa-user-circle text-blueGray-400 mr-2 text-sm"></i>{" "}
                  登出
                </Link>
              </li>
            </ul>


          </div>
        </div>
      </nav>
    </>
  );
}
